export default "__VITE_ASSET__tNq5LNeC__"